import React from 'react'
import CompanyLogo from '../../assets/Images/companyDefault.png'

const InterviewDetails = ({interviewData}) => {
  return (
    <div>
        <h1 className='font-semibold text-xl mb-5'>Interview Details</h1>
        <img className='w-10 h-10' src={interviewData?.avatar || CompanyLogo} alt="" />
        <div className='mt-2 flex items-start justify-between'>
            <div className='w-1/2'>
                <h1 className='font-semibold text-md'>Interview Type</h1>
                <p className='text-neutral-600'>{interviewData?.typeOfInterview}</p>
            </div>

            <div className='w-1/2'>
                <h1 className='font-semibold text-md'>Interview Location</h1>
                <p className='text-neutral-600'>{interviewData?.interviewLocation}</p>
            </div>
        </div>


        <div className='mt-5 flex items-start justify-between'>
            <div className='w-1/2'>
                <h1 className='font-semibold text-md'>Interview Date</h1>
                <p className='text-neutral-600'>{interviewData?.interviewDate}</p>
            </div>

            <div className='w-1/2'>
                <h1 className='font-semibold text-md'>Interview Time</h1>
                <p className='text-neutral-600'>{interviewData?.interviewTime}</p>
            </div>
        </div>

        <div className='mt-8'>
            <h1 className='font-semibold text-md'>Additional Information</h1>
            <p className='text-neutral-600'>{interviewData?.additionalInformation}</p>
        </div>
        
    </div>
  )
}

export default InterviewDetails